var _defs, _g, _g2, _g3, _g4, _g5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStudentMonitorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1080,
    zoomAndPan: "magnify",
    viewBox: "0 0 810 1012.49997",
    height: 1350,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "90ac6b1c34"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 52.453125 674 L 177 674 L 177 877.425781 L 52.453125 877.425781 Z M 52.453125 674 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "7c9c1d5155"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 245 646 L 371 646 L 371 877.425781 L 245 877.425781 Z M 245 646 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "39d11b846b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 438 578 L 568 578 L 568 877.425781 L 438 877.425781 Z M 438 578 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "4cc8fed7ff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 635 459 L 757.855469 459 L 757.855469 877.425781 L 635 877.425781 Z M 635 459 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c53b52a7f3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 52.453125 134.542969 L 757.855469 134.542969 L 757.855469 607 L 52.453125 607 Z M 52.453125 134.542969 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#90ac6b1c34)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 52.496094 674.597656 L 176.796875 674.597656 L 176.796875 877.425781 L 52.496094 877.425781 Z M 52.496094 674.597656 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7c9c1d5155)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 245.277344 877.425781 L 245.277344 646.703125 L 370.628906 646.703125 L 370.628906 877.425781 Z M 245.277344 877.425781 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#39d11b846b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 438.074219 578.238281 L 567.445312 578.238281 L 567.445312 877.425781 L 438.074219 877.425781 Z M 438.074219 578.238281 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4cc8fed7ff)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 635.925781 459.085938 L 757.695312 459.085938 L 757.695312 877.425781 L 635.925781 877.425781 Z M 635.925781 459.085938 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c53b52a7f3)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 52.496094 605.085938 C 52.496094 605.085938 382.269531 560.582031 608.03125 261.3125 L 534.460938 213.148438 L 757.746094 134.542969 L 757.746094 369.8125 L 696.851562 317.089844 C 696.851562 317.089844 420.308594 629.371094 52.496094 605.085938 Z M 52.496094 605.085938 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentMonitorIcon);
export default __webpack_public_path__ + "static/media/Student_monitor_icon.425756bf722389e705169038886477f2.svg";
export { ForwardRef as ReactComponent };